import { createFileRoute, redirect } from '@tanstack/react-router';

import { ROUTES } from '@/config/routes';
import { canManageSso } from '@/host/access';
import { AuthPolicyView } from '@/platform/orgs/AuthPolicyView';

export const Route = createFileRoute('/_app/auth-policy')({
   beforeLoad: ({ context }) => {
      if (!canManageSso(context.user)) throw redirect({ to: ROUTES.HOME, replace: true });
   },
   component: AuthPolicyView
});
